import { BookOpen } from "lucide-react";
import { ModuleHeader } from "./VideoCarousel";
import { resolveMedia } from "@/api/client";
import { trJourney } from "@/config/journeyI18n";
import { useLanguage } from "@/context/LanguageContext";

// "Darshan" — a 3D tilted carousel of the twelve Canto covers with 2-3
// highlighted story lines per volume. Covers fall back to an elegant
// placeholder tile until an admin uploads the artwork.
export const CantoCarousel = ({ module }) => {
  const { lang } = useLanguage();
  const cantos = module.cantos || [];
  if (!cantos.length) return null;
  return (
    <div data-testid={`journey-canto-${module.id}`} className="mx-auto max-w-6xl px-5">
      <ModuleHeader title={module.title} subtitle={module.subtitle} />
      <div
        className="mt-10 flex snap-x gap-6 overflow-x-auto pb-8 pt-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        style={{ perspective: "1400px" }}
      >
        {cantos.map((c, i) => (
          <div
            key={c.id || i}
            data-testid={`canto-card-${i}`}
            className="group w-[74vw] max-w-[280px] shrink-0 snap-center sm:w-[260px]"
          >
            <div
              className="transition-transform duration-500 will-change-transform [transform:rotateY(-16deg)_rotateX(4deg)] group-hover:[transform:rotateY(0deg)_rotateX(0deg)]"
              style={{ transformStyle: "preserve-3d" }}
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden rounded-xl border border-amber-300/25 bg-gradient-to-br from-[#241a3d] via-[#141a2e] to-[#0a0f24] shadow-[0_25px_60px_-15px_rgba(0,0,0,0.7)]">
                {c.cover ? (
                  <img src={resolveMedia(c.cover)} alt={c.title} loading="lazy" className="h-full w-full object-cover" />
                ) : (
                  <div className="flex h-full w-full flex-col items-center justify-center gap-3 p-4 text-center">
                    <BookOpen className="h-8 w-8 text-amber-300/70" />
                    <span className="font-display text-lg text-amber-200/90">{trJourney(c.title, lang)}</span>
                  </div>
                )}
                <div className="pointer-events-none absolute inset-y-0 left-0 w-3 bg-gradient-to-r from-black/40 to-transparent" />
              </div>
            </div>
            <div className="mt-4 px-1">
              <p className="font-display text-base text-amber-200">{trJourney(c.title, lang)}</p>
              <ul className="mt-2 space-y-1">
                {(c.lines || []).slice(0, 3).map((line, li) => (
                  <li key={li} className="flex items-start gap-2 text-xs text-amber-50/55">
                    <span className="mt-1 h-1 w-1 shrink-0 rounded-full bg-amber-400" />
                    {trJourney(line, lang)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
